import { configOption, KahunConfigurationOptionType } from "../lib/annotations";
export enum suggestedQuestionOption {
    "Never"= "Never",
    "A/B testing" = "A/B testing",
    "Always" = "Always",
}
export class DialogueOptions {
  @configOption({
    description: "Is the Dialogue chat (RAG) enabled on clinic manage",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  enabled: boolean = false;

  @configOption({
    description: "The app name of the Dialogue chat (RAG) to use",
    displayType: KahunConfigurationOptionType.String,
  })
  dialogueApp: string;

  @configOption({
    description: "Suggest questions to the user in the chat",
    displayType: KahunConfigurationOptionType.Choice,
    options: suggestedQuestionOption,
  })
  showSuggestedQuestions: suggestedQuestionOption = suggestedQuestionOption.Always;

  @configOption({
    description: "Show chat history",
    displayType: KahunConfigurationOptionType.Boolean,
  })
  showChatHistory: boolean = true;
}